// third-party
import { FormattedMessage } from 'react-intl';

// assets
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';

// icons
const icons = { DocumentScannerOutlinedIcon, MedicalServicesIcon, FileTextOutlined };

// ==============================|| MENU ITEMS - RADIOLOGY ||============================== //

const radiology = {
  id: 'radiology',
  title: <FormattedMessage id="Radiology" />,
  icon: icons.MedicalServicesIcon,
  type: 'group',
  visible: (roles, isAdmin) => roles.includes('radiologist') || isAdmin,
  children: [
    {
      id: 'radiology-management',
      key: 'radiology-management',
      title: <FormattedMessage id="Radiology Management" />,
      type: 'item',
      url: '/labs/radiology-management',
      icon: icons.DocumentScannerOutlinedIcon,
      visible: (roles, isAdmin) => roles.includes('radiologist') || isAdmin
    },
    {
      id: 'radiology-templates',
      title: <FormattedMessage id="Radiology Templates" />,
      type: 'item',
      url: '/labs/radiology-templates',
      icon: icons.FileTextOutlined,
      visible: (roles, isAdmin) => roles.includes('radiologist') || roles.includes('doctor') || isAdmin
    }
  ]
};

export default radiology;

